import { useMediaQuery, useTheme } from '@material-ui/core';

export function useIsMobileView(): boolean {
  return !useMediaQuery(useTheme().breakpoints.up('sm'));
}
